module.exports = __webpack_public_path__ + "img/5.1f566825.jpg";